import { CTA, Hero, SplitProof } from "../components/Section";
import { SectionHeading } from "../components/SectionHeading";
import { aboutValues } from "../content/site";
import { workImageSets } from "../content/workImages";

export function AboutPage() {
  return (
    <>
      <Hero
        images={workImageSets.aboutHero}
        title="A fabrication and installation partner focused on precision, reliability, and lasting results."
        copy="Metalworks & Design Group supports contractors, developers, and project teams by transforming concepts, drawings, and field conditions into high-quality fabricated metal solutions. From detailing and fabrication to finishing, delivery, and installation, we provide the expertise and craftsmanship needed to keep projects moving forward."
        primary={{ label: "Talk With the Shop", href: "/contact" }}
      />
      <section className="about-story section-pad" data-reveal>
        <div>
          <SectionHeading
            eyebrow="How We Work"
            title="Every project is treated as a chain of practical choices."
          />
        </div>
        <p>
          The work starts by understanding the use case: what the part needs to carry, where it will live, what finish it needs, and how it will be installed or handed off. From there, the team can recommend a fabrication path that respects cost, schedule, material behavior, and visual expectations.
        </p>
        <p>
          This prototype keeps the public message concise until the client confirms shop history, leadership details, certifications, and photography. The structure is ready for those details without requiring a redesign.
        </p>
      </section>
      <SplitProof
        eyebrow="Operating Values"
        title="Quiet discipline from first review to finished work."
        copy="The site language intentionally emphasizes precision, routing, and delivery because those ideas match how fabrication buyers evaluate risk."
        items={aboutValues}
      />
      <CTA
        title="Have a project that needs a fabrication-minded review?"
        copy="Send the context you have. Drawings, photos, measurements, and open questions are all useful starting points."
        label="Start the Conversation"
        href="/contact"
      />
    </>
  );
}
